import React, { useEffect, useState } from 'react';
import { Fade, Typography } from '@mui/material';
import Lottie from 'lottie-react';

interface LottieLoaderProps {
  lottieJson: any;
  containerStyles?: React.CSSProperties;
  loadingMessages?: Array<string>;
  loadingMessageContainerStyles?: React.CSSProperties;
  animationStyles?: React.CSSProperties;
}

const animationTimeOut = 800;

const LottieLoader: React.FC<LottieLoaderProps> = ({
  lottieJson,
  loadingMessages = [],
  containerStyles = {},
  loadingMessageContainerStyles = {},
  animationStyles = {},
}) => {
  // State
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);

  useEffect(() => {
    let timer: NodeJS.Timeout;

    if (currentMessageIndex < loadingMessages.length - 1) {
      timer = setTimeout(() => {
        setCurrentMessageIndex((prevIndex) => prevIndex + 1);
      }, 3000);
    }

    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [currentMessageIndex]);

  return (
    <Fade in timeout={animationTimeOut}>
      <div
        style={{
          minHeight: 'calc(100vh)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          ...containerStyles,
        }}
      >
        <Lottie
          loop
          animationData={lottieJson}
          style={{ maxWidth: '100%', height: '400px', ...animationStyles }}
        />
        {loadingMessages.length ? (
          <div style={{ paddingTop: '30px', ...loadingMessageContainerStyles }}>
            <Fade in key={currentMessageIndex} timeout={animationTimeOut}>
              <Typography
                variant="h6"
                sx={{ textAlign: 'center', color: 'text.secondary' }}
              >
                {loadingMessages[currentMessageIndex]}
              </Typography>
            </Fade>
          </div>
        ) : null}
      </div>
    </Fade>
  );
};

export default LottieLoader;
